<template>
  <div class="row help-wrapper">
    <!-- <header-about /> -->
    <div id="corpo" class="col s12">
      <div class="center offline col s12">
        <img src="/static/images/icons/icon-512x512.png" class="center" width="30%" />
      </div>
      <div class="col s12"></div>
      <p class="center">
        {{ current_version }}
        <br />
        Recad Censo®
        <br />
        Todos os direitos reservados.
      <div class="col s12 center">
        <router-link v-bind:to="last_page" class="waves-effect waves-light btn btn-theme fAboutLogin center s12" id="abouBtnLogin">
          Voltar
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import HeaderAbout from "@/components/HeaderAbout.vue"
import HoldArea from "@/components/utils/HoldArea.vue"
var package_json = require('../../package.json');

export default {
  name: 'Sobre',
  components: {
    "header-about": HeaderAbout,
    "hold-area": HoldArea,
  },
  data (){
    return {
      active_step: 1,
      last_page: this.$store.state.route.from.fullPath,
      current_version: package_json.version
    }
  },
  methods: {
    easterEgg(dev){
      let devs = {
        'aninha': {
          'inv': 'ANINHA',
          'name': 'Ana Veloso',
          'msg': 'Social media entrando no mundo da programação web'
        },
        '4ndr': {
          'inv': '4NDR',
          'name': 'André Leite',
          'msg': 'Trying to understand how the world works and why things are the way they are'
        },
        'hugor': {
          'inv': 'Hugor',
          'name': 'Hugo Lima',
          'msg': 'Frontend Developer Since 2009, I Have Worked With Javascript, HTML5, CSS3, WordPress And SEO. I am learning and programming in Vue.Js actually.'
        },
        'rinzler': {
          'inv': 'RINZLR',
          'name': 'Feliphe Bueno',
          'msg': 'There he stands alone, one man against all'
        }, 
        'raff': {
          'inv': 'RAFF',
          'name': 'Raul Afonso',
          'msg': 'The first rule about fight club is, you dont talk about fight club'
        }
      }
      let dev_info = devs[dev]
      this.$refs[dev].innerHTML = (this.$refs[dev].innerHTML === dev_info.name ? dev_info.inv : dev_info.name)
      M.toast({html: dev_info['msg']})
    },
    initMaterialize() {
      setTimeout(() => {
        M.Collapsible.init((document.querySelectorAll('.collapsible')))
        M.Materialbox.init(document.querySelectorAll('.materialboxed'))
      }, 100)
    }
  },
  mounted(){
    this.$root.$emit('stopLoadingHeader')
    this.initMaterialize()
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Sobre.vue